
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

interface CertificateTrackingStatsProps {
  totalCertificates: number;
  reported: number;
  verified: number;
  unreported: number;
  unverified: number;
  isLoading?: boolean;
}

export function CertificateTrackingStats({
  totalCertificates,
  reported,
  verified,
  unreported,
  unverified,
  isLoading = false
}: CertificateTrackingStatsProps) {
  const reportingPercentage = totalCertificates > 0 
    ? Math.round((reported / totalCertificates) * 100) 
    : 0;
    
  const verificationPercentage = totalCertificates > 0 
    ? Math.round((verified / totalCertificates) * 100) 
    : 0;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="text-center">
            <p className="text-sm font-medium text-muted-foreground">Total Certificates</p>
            <p className="text-3xl font-bold">
              {isLoading ? '—' : totalCertificates}
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-6">
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>Reporting Status</span>
                <span className="font-medium">
                  {isLoading ? '—' : `${reportingPercentage}%`}
                </span>
              </div>
              <Progress 
                value={isLoading ? 0 : reportingPercentage} 
                className="h-2" 
              />
              <div className="flex justify-between text-xs text-muted-foreground mt-1">
                <span>Reported: {isLoading ? '—' : reported}</span>
                <span>Unreported: {isLoading ? '—' : unreported}</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-6">
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>Verification Status</span>
                <span className="font-medium">
                  {isLoading ? '—' : `${verificationPercentage}%`}
                </span>
              </div>
              <Progress 
                value={isLoading ? 0 : verificationPercentage} 
                className="h-2" 
              />
              <div className="flex justify-between text-xs text-muted-foreground mt-1">
                <span>Verified: {isLoading ? '—' : verified}</span>
                <span>Unverified: {isLoading ? '—' : unverified}</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
